export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="relative min-h-[85vh] flex items-center pt-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 w-full">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          {/* Left Content */}
          <div className="flex-1 lg:w-[45%] space-y-8">
            <div className="inline-block">
              <span className="text-[#2d9b9b] text-sm font-semibold tracking-widest uppercase">
                Organizational Strategy &amp; Executive Coaching
              </span>
            </div>

            <h1 className="text-3xl lg:text-5xl font-bold text-[#1a2b4a] leading-tight" style={{ fontFamily: 'Crimson Text, serif' }}>
              Aligning Strategy, Leadership, and People Systems for Mission-Driven Organizations
            </h1>

            <p className="text-lg lg:text-xl text-[#1a2b4a]/70 leading-relaxed max-w-xl">
              I help nonprofit and social impact leaders navigate organizational change, strengthen leadership teams, and align people systems with strategy so their organizations can deliver greater impact.
            </p>

            <button
              onClick={scrollToContact}
              className="inline-flex items-center gap-2 bg-[#2d9b9b] text-white px-8 py-4 rounded-full hover:bg-[#258080] transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              Schedule a Consultation
              <i className="ri-arrow-right-line text-lg"></i>
            </button>
          </div>

          {/* Right Visual */}
          <div className="flex-1 lg:w-[55%] relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/8c6284e4b6fb6542dca16bf3f3ba369a.jpg"
                alt="Leadership collaboration"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-br from-[#2d9b9b]/20 via-transparent to-[#1a2b4a]/10"></div>
            </div>

            {/* Decorative Element */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 opacity-20">
              <div className="grid grid-cols-4 gap-2">
                {[...Array(16)].map((_, i) => (
                  <div key={i} className="w-2 h-2 rounded-full bg-[#1a2b4a]"></div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}